import type { ChangeEvent, ChangeEventHandler } from 'react';

export default function eventTargetValue<T extends HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>(
    handler: (value: string) => void,
): ChangeEventHandler<T> {
    return (event: ChangeEvent<T>) => {
        handler(event.target.value);
    };
}
